import store from 'store';
import enTranslations from 'assets/localization/translations/en.locale.json';
import frTranslations from 'assets/localization/translations/fr.locale.json';
import nlTranslations from 'assets/localization/translations/nl.locale.json';
import { deepDiver } from 'helpers/utilities';

const translations = {
  en: enTranslations,
  fr: frTranslations,
  nl: nlTranslations,
};

const DEFAULT_KEY = 'en';

export const getCurrentLocale = () => {
  if (!window || !window.localStorage)
    throw Error('getCurrentLocale must be called in the browser');

  if (window.localStorage.locale) return window.localStorage.locale;

  // Default languages if locale is not stored.
  if (
    store.getState().userTypes.defaultLanguages &&
    store.getState().userTypes.defaultLanguages.length > 0
  ) {
    return store.getState().userTypes.defaultLanguages[0];
  }

  return DEFAULT_KEY;
};

// otherwise : a text used if the key is not found in global.local.json.
export const getTranslatedString = (key, params, otherwise = null) => {
  if (!window || !window.localStorage)
    throw Error('getTranslatedString must be called in the browser');

  const locale = getCurrentLocale();
  let string = translations[locale][key];

  if (!string) {
    string = otherwise;
  }

  if (!string && locale !== DEFAULT_KEY && window.ENV === 'production') {
    window.Rollbar.error(`MISSING ${locale} translations for ${key}`);
    string = translations[DEFAULT_KEY][key];
  }

  if (!string) {
    window.Rollbar.error(`MISSING ALL translations for ${key}`);
    return `MISSING  ${key}`;
  }
  return interpolate(string, params);
};

// This function is useful for translating things that could be user input OR certain fixed values
// Example is name and description of batches
// They could be entered by user, or they could be generated by system in which case it needs to be translated
// If the parameter is formatted like: $T:key then the key will be translated
// otherwise the original value will be used
export const getTranslatedName = name => {
  if (typeof name === 'string' && name.startsWith('$T') && !!name.split('|')[1]) {
    const translateVariables = name.split('|')[1];
    const arrayOfVariablesForTranslate = translateVariables.split(', ');
    let translateVariablesObject = {};
    arrayOfVariablesForTranslate.map(
      keyPair => (translateVariablesObject[keyPair.split(':: ')[0]] = keyPair.split(':: ')[1])
    );

    return getTranslatedString(name.split(':')[1].split('|')[0], translateVariablesObject);
  } else if (typeof name === 'string' && name.startsWith('$T')) {
    return getTranslatedString(name.split(':')[1]);
  } else {
    return name;
  }
};

export const getLandlordVerbiageOrTranslatedString = (
  verbiageKey,
  params,
  verbiagesPassed = null
) => {
  const locale = getCurrentLocale();
  const verbiages = verbiagesPassed || store.getState().userTypes?.verbiages;

  if (verbiages && deepDiver(verbiages, verbiageKey) && deepDiver(verbiages, verbiageKey)[locale]) {
    return interpolate(deepDiver(verbiages, verbiageKey)[locale], params);
  }

  return getTranslatedString(verbiageKey, params);
};

function interpolate(string, params) {
  if (!params) return string;

  return string
    .split('${')
    .reduce((prev, curr, i) => {
      if (i === 0) return prev.concat([curr]);
      return prev.concat(curr.split('}'));
    }, [])
    .reduce((prev, curr, i) => {
      if (i % 2 === 0) {
        return prev + curr;
      } else {
        return prev + params[curr];
      }
    }, '');
}

const c = {};
Object.keys(translations.en).forEach(key => {
  c[key] = {
    copy: { en: translations.en[key], fr: translations.fr[key], nl: translations.nl[key] },
  };
});

export const contentNodes = c;
